import { getAuthSession, headers } from '@/helpers';
import { type KycCountriesListResponseDTO } from '@/types/consumer-deposit-application-service';
const countryUrl = `${import.meta.env.VITE_RESURS_EKS_HOST}/api/consumer_deposit_application_service/kyc/countries`;

export const fetchCountries = async (): Promise<KycCountriesListResponseDTO> =>
  get();

const get = async (): Promise<KycCountriesListResponseDTO> => {
  const { accessToken } = getAuthSession();

  return fetch(`${countryUrl}`, {
    headers: headers(accessToken),
    method: 'GET',
  }).then(async (response) => {
    if (response.status !== 200) {
      throw Error(
        `Could not fetch KYC countries ${JSON.stringify(await response.json())}`,
      );
    }

    return response.json().then((json: KycCountriesListResponseDTO) => json);
  });
};
